import { Widget } from "@/lib/form/types"
import {
  ParamGradeLabel,
  ParamGradeRange,
  ParamSchemaType,
} from "@/lib/form/schema"
import { RefObject, useRef, useState } from "react"
import ChoiceWidget from "@/lib/form/widgets/choice"
import LimitWidget from "@/lib/form/widgets/limit"

const defaultWidgets: Partial<Record<WidgetType, Widget>> = {
  [ParamSchemaType.VALUE_TEXT]: LimitWidget,
  [ParamSchemaType.VALUE_NUMBER]: LimitWidget,
  [ParamSchemaType.CHOICE]: ChoiceWidget,
}

export function useWidgetRegistry(
  customWidgets?: Partial<Record<WidgetType, Widget>>
): WidgetRegistry {
  const widgets = useRef<Partial<Record<WidgetType, Widget>>>({
    ...defaultWidgets,
    ...(customWidgets ? customWidgets : {}),
  })
  const [__, setTick] = useState(0)

  function get(type: WidgetType) {
    return widgets.current[type] || false
  }

  function add(
    type: WidgetType,
    widget: Widget,
    options?: Partial<AddWidgetOptions>
  ) {
    widgets.current[type] = widget

    if (options?.render) {
      setTick((curr) => curr + 1)
    }
  }

  return {
    widgets,
    get,
    add,
  }
}

export type WidgetType = ParamSchemaType | (string & {})

export interface AddWidgetOptions {
  render?: boolean
}

export type WidgetRegistry = {
  widgets: RefObject<Partial<Record<WidgetType, Widget>>>
  get: (type: WidgetType) => Widget | false
  add: (
    type: WidgetType,
    widget: Widget,
    options?: Partial<AddWidgetOptions>
  ) => void
}

/**
 * Get range label by passing value
 * and grade range list
 */
export function findGradeRangeLabel(
  value: any,
  ranges: ParamGradeRange[]
): ParamGradeLabel {
  if (typeof value === "string" && !value) {
    return ParamGradeLabel.None
  }

  const range = ranges.find((range) => value >= range.min && value <= range.max)

  return range?.gradeLabel || ParamGradeLabel.None
}
